import { Button } from 'antd';
import { FC } from 'react';

import {
  PendingDaysFilter,
  PendingDaysLabels,
  PendingDaysStatus,
} from '../../types';

interface IProps {
  totalCount: number;
  filter: PendingDaysFilter;
  counts: Record<PendingDaysStatus, number>;
  labels?: { [K in keyof PendingDaysLabels]?: string | null };
  onChange: (filter: PendingDaysFilter) => void;
}

const PendingDaysFilterBar: FC<IProps> = ({
  totalCount,
  filter,
  counts,
  labels,
  onChange,
}) => {
  const buttons: Array<{
    value: PendingDaysFilter;
    label: string;
    activeColor: string;
    inactiveBg?: string;
  }> = [
    {
      value: 'all',
      label: `All (${totalCount})`,
      activeColor: '#0e4d8f',
    },
    {
      value: 'onTrack',
      label: `${labels?.low || 'On Track'} (${counts.onTrack})`,
      activeColor: '#389e0d',
      inactiveBg: '#f6ffed',
    },
    {
      value: 'approaching',
      label: `${labels?.mid || 'Approaching'} (${counts.approaching})`,
      activeColor: '#faad14',
      inactiveBg: '#fffbe6',
    },
    {
      value: 'overdue',
      label: `${labels?.high || 'Overdue'} (${counts.overdue})`,
      activeColor: '#f31a25',
      inactiveBg: '#fff2f0',
    },
  ];

  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 8, marginTop: 4 }}>
      {buttons.map(({ value, label, activeColor, inactiveBg }) => {
        const isActive = filter === value;
        return (
          <Button
            key={value}
            size="small"
            style={{
              backgroundColor: isActive ? activeColor : inactiveBg,
              color: isActive ? '#fff' : activeColor,
              borderColor: activeColor,
              fontWeight: 600,
            }}
            onClick={() =>
              onChange(value !== 'all' && isActive ? 'all' : value)
            }
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};

export default PendingDaysFilterBar;
